'use client';

import {forwardRef, HTMLAttributes, ReactNode} from 'react';
import {cn} from '../../libs';

interface MenuProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hasEmptyItem?: boolean;
}

export const Menu = forwardRef<HTMLDivElement, MenuProps>(
  ({children, hasEmptyItem = true, ...rest}, ref) => (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'flex w-full flex-col gap-px rounded-md border bg-bg-secondary p-1 text-text-primary shadow-md',
        rest.className,
      )}
      role="listbox"
    >
      {hasEmptyItem && <div role="option" tabIndex={0} />}
      {children}
    </div>
  ),
);

Menu.displayName = 'Menu';
